//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { server } from "@/services/constants";
import api from "@/services/api";
import Hashids from "hashids";

export default {
    name: "TimeLineOperations",
    props: {
        modeOperations: {
            type: String,
            required: true
        },
        showaddItem: {},
        statuslist: {
            type: Array,
            default: () => []
        },
        reportlist: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            encodedid: "",
            snackbar: false,
            snackbarText: "",
            snackbarColor: "success",
            tab: 1,
            visible: true,
            currentDateTime: '',
            caseWorkerName: '',
            cssStatus: [
                {
                    status: "In Progress",
                    color: "#FFF7ED",
                    iconColor: "#D97706",
                    icon: "mdi-loading"
                },
                {
                    status: "Waiting for Client",
                    color: "#FEFCE8",
                    iconColor: "#CA8A04",
                    icon: "mdi-message-alert-outline"
                },
                {
                    status: "Waiting for Third Party",
                    color: "#ECFEFF",
                    iconColor: "#0891B2",
                    icon: "mdi-timer-sand"
                },
                {
                    status: "Internal Review",
                    color: "#EEF2FF",
                    iconColor: "#4F46E5",
                    icon: "mdi-clipboard-check-outline"
                },
                {
                    status: "Payment Pending",
                    color: "#FFF7ED",
                    iconColor: "#EA580C",
                    icon: "mdi-credit-card-outline"
                },
                {
                    status: "Completed",
                    color: "#F0FDF4",
                    iconColor: "#16A34A",
                    icon: "mdi-check-circle"
                },
                {
                    status: "On Hold",
                    color: "#FEF2F2",
                    iconColor: "#DC2626",
                    icon: "mdi-pause-circle"
                },
                {
                    status: "Cancelled",
                    color: "#F8FAFC",
                    iconColor: "#475569",
                    icon: "mdi-close-circle"
                },
                {
                    status: "Closed",
                    color: "#F0FDF4",
                    iconColor: "#15803D",
                    icon: "mdi-archive"
                }
            ],
            timelineData: [
                {
                    status: "In Progress",
                    date: "15/05/2026 09:30 AM",
                    desc: "Work on this request has started and is currently being processed by the assigned team.",
                    updatedAt: "15/05/2026 10:15 AM",
                    color: "#FFF7ED",
                    iconColor: "#D97706",
                    icon: "mdi-loading"
                },
                {
                    status: "Waiting for Client",
                    date: "14/05/2026 03:45 PM",
                    desc: "Additional information or confirmation ",
                    updatedAt: "14/05/2026 04:10 PM",
                    color: "#FEFCE8",
                    iconColor: "#CA8A04",
                    icon: "mdi-message-alert-outline"
                },
                {
                    status: "Waiting for Third Party",
                    date: "14/05/2026 11:20 AM",
                    desc: "The process is currently pending a response or action from an external third party.",
                    updatedAt: "14/05/2026 12:00 PM",
                    color: "#ECFEFF",
                    iconColor: "#0891B2",
                    icon: "mdi-timer-sand"
                },
                {
                    status: "Internal Review",
                    date: "13/05/2026 02:15 PM",
                    desc: "This request is under internal review for validation and quality checking.",
                    updatedAt: "13/05/2026 03:00 PM",
                    color: "#EEF2FF",
                    iconColor: "#4F46E5",
                    icon: "mdi-clipboard-check-outline"
                },
                {
                    status: "Payment Pending",
                    date: "13/05/2026 10:00 AM",
                    desc: "Awaiting payment confirmation before the request can move to the next stage.",
                    updatedAt: "13/05/2026 10:30 AM",
                    color: "#FFF7ED",
                    iconColor: "#EA580C",
                    icon: "mdi-credit-card-outline"
                },
                {
                    status: "Completed",
                    date: "12/05/2026 05:45 PM",
                    desc: "All required actions have been successfully completed.",
                    updatedAt: "12/05/2026 06:00 PM",
                    color: "#F0FDF4",
                    iconColor: "#16A34A",
                    icon: "mdi-check-circle"
                },
                {
                    status: "On Hold",
                    date: "12/05/2026 01:10 PM",
                    desc: "This request has been temporarily paused and will resume once pending issues are resolved.",
                    updatedAt: "12/05/2026 01:45 PM",
                    color: "#FEF2F2",
                    iconColor: "#DC2626",
                    icon: "mdi-pause-circle"
                },
                {
                    status: "Cancelled",
                    date: "11/05/2026 04:20 PM",
                    desc: "This request has been cancelled and will not proceed further.",
                    updatedAt: "11/05/2026 04:35 PM",
                    color: "#F8FAFC",
                    iconColor: "#475569",
                    icon: "mdi-close-circle"
                },
                {
                    status: "Closed",
                    date: "11/05/2026 09:00 AM",
                    desc: "This request has been officially closed and archived for record purposes.",
                    updatedAt: "11/05/2026 09:20 AM",
                    color: "#F0FDF4",
                    iconColor: "#15803D",
                    icon: "mdi-archive"
                }
            ]
        };
    },
    async mounted() {
        await this.initPage();
    },

    methods: {
        async initPage() {
            this.$showLoader();

            try {
                var mainid = "26351";
                const hashids = new Hashids("my-secret-salt", 8);
                const encoded = hashids.encode(mainid);
                this.encodedid = encoded;

                this.caseWorkerName = await this.getCaseWorkerName();
                this.currentDateTime = this.getCurrentDateTime();
            } catch (err) {
                console.error(err);
            } finally {
                this.$hideLoader();
            }
        },

        async getCaseWorkerName() {
            let workerName = "";

            const userId = localStorage.getItem(server.USER_ID);

            const result = await api.getAccountByid(userId);

            if (result?.data?.length > 0) {
                workerName = result.data[0].name;
            }

            return workerName;
        },

        getCurrentDateTime() {
            const now = new Date();

            const day = String(now.getDate()).padStart(2, '0');
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const year = now.getFullYear();

            return `${day}/${month}/${year}`;
        },

        copyLinkClientPreview() {
            const localUrl = window.location.origin;
            const text = `${localUrl}/client-view/case/${this.encodedid}`

            navigator.clipboard.writeText(text)
                .then(() => {
                    this.snackbarText = "Copy สำเร็จ 🎉"
                    this.snackbarColor = "success"
                    this.snackbar = true
                })
                .catch((err) => {
                    console.error("Copy failed:", err)

                    this.snackbarText = "Copy ไม่สำเร็จ ❌"
                    this.snackbarColor = "error"
                    this.snackbar = true
                })
        }
    }
};
